<template>
  <div
    class="f-project-tabs"
    v-resize
    @resize="projectTabsSize = $event.detail.width"
    ref="projectTabs"
    :style="{ '--maxWidth': `${tabMaxSize}px` }"
  >
    <div class="left" v-resize @resize="leftSize = $event.detail.width">
      <div
        class="tabs-container"
        :class="{ 'hide-last-separator': !$slots.new }"
        v-resize
        @resize="tabsContainerSize = $event.detail.width"
      >
        <div
          class="tabs-container-inner"
          ref="tabsInnerContainer"
          :class="{ 'dnd-styles': dndStyles }"
          v-resize
          @resize="containerSlotSize = $event.detail.width"
        >
          <slot name="default"></slot>
        </div>
      </div>
      <div
        class="new"
        ref="new"
        @click="$emit('select', undefined)"
        v-resize
        @resize="newSize = $event.detail.width"
      >
        <f-wrapper v-if="$slots.new">
          <slot name="new"> </slot>
        </f-wrapper>
      </div>
    </div>
    <div
      class="info"
      ref="info"
      v-resize
      @resize="infoSize = $event.detail.width"
    >
      <slot name="info"> </slot>
    </div>
    <div class="action" v-if="$slots.action">
      <slot name="action"> </slot>
    </div>
  </div>
</template>

<script>
import { debug } from "/vodalys/.jslibs";
const log = debug("FProjectTabs");

import { findMaxTabSize } from "./FProjectTabsUtils.mjs";

const TABSIZE_INC = 40;

// import { resize } from "/vodalys/vvuejs_lib_resize_detector/vvuejs_lib_resize_detector.parcel.mjs";
export default {
  directives: {
    // resize,
  },
  props: {
    dndStyles: Boolean,
  },
  data() {
    return {
      projectTabsSize: undefined,
      leftSize: undefined,
      tabsContainerSize: undefined,
      containerSlotSize: undefined,
      newSize: undefined,
      infoSize: undefined,
      tabMaxSize: undefined,
      containerSpaceAvailable: undefined,
    };
  },
  computed: {
    change() {
      return `${this.projectTabsSize} + ${this.tabsContainerSize} + ${this.containerSlotSize} + ${this.leftSize} + ${this.newSize} + ${this.infoSize}`;
    },
  },
  watch: {
    change() {
      this.resizeStuff();
    },
  },
  methods: {
    resizeStuff() {
      const tabsItems = Array.from(
        this.$refs.tabsInnerContainer.querySelectorAll(".tab-container")
      );

      if (tabsItems.length === 0) {
        log("no tab item");
        return;
      }

      const tabsItemsWidths = tabsItems.map((tabItem) => {
        return tabItem.getBoundingClientRect().width;
      });

      let childCount =
        (this.$refs.tabsInnerContainer &&
          this.$refs.tabsInnerContainer.querySelector(
            ".smooth-dnd-container"
          ) &&
          this.$refs.tabsInnerContainer.querySelector(".smooth-dnd-container")
            .childElementCount) ||
        1;

      this.containerSpaceAvailable =
        this.projectTabsSize - this.newSize - this.infoSize - TABSIZE_INC;

      if (!this.tabMaxSize) {
        log("init");
        // this.tabMaxSize = this.containerSpaceAvailable / childCount;
        this.tabMaxSize = findMaxTabSize(
          tabsItemsWidths,
          this.containerSpaceAvailable,
          TABSIZE_INC
        );
      } else if (this.containerSpaceAvailable < this.containerSlotSize) {
        log("slot bigger");
        this.tabMaxSize = findMaxTabSize(
          tabsItemsWidths,
          this.containerSpaceAvailable,
          TABSIZE_INC
        );
      } else if (
        this.containerSpaceAvailable > this.containerSlotSize + TABSIZE_INC &&
        this.tabMaxSize < this.containerSpaceAvailable
      ) {
        log("slot way smaller");
        this.tabMaxSize = this.tabMaxSize + TABSIZE_INC / childCount;
      } else {
        log("OK");
      }
    },
  },
  mounted() {
    // this.interval = setInterval(() => {
    //   this.resizeStuff();
    // }, 2500);
  },
  destroyed() {
    // clearInterval(this.interval);
    // delete this.interval;
  },
};
</script>


<style lang="scss" scoped >
.f-wrapper {
  height: 40px;
}
</style>

<style lang="scss">
.f-project-tabs {
  /* Tabs */

  overflow: hidden;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px 16px 0px;

  height: 54px;

  background: #2D2D2E;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 0px;

  .tabs-container.hide-last-separator {
    .f-project-tab-container:last-of-type .separator {
      border-right: 1px solid transparent;
    }
  }

  .left {
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
  }

  .tabs-container {
    > .tabs-container-inner {
      display: inline-flex;
      flex-direction: row;

      &.dnd-styles {
        display: inline-block;
      }

      .smooth-dnd-drop-preview-constant-class *
      {
        background-color: #404040;
        border-radius: 8px 8px 0px 0px;
      }
    }

    // $max-width: 26em;

    // max-width: 80%;
    .tab-container {
      max-width: var(--maxWidth);
    }
  }

  .new {
    /* Add module configuration tab */

    /* Auto layout */

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 4px;

    height: 48px;
    margin: 0px 0px;

    /* Add */

    /* Navigation/Item/Medium/Default */

    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;

    /* Black / 50% */

    color: var(--white-a50);

    margin: 0px 4px;

    .f-wrapper
    {
      &:hover
      {
        background-color: var(--white-a10);
      }
    }
  }

  .info {
    flex: 1 0 auto;

    padding-left: 24px;
    align-self: center;
    justify-self: flex-end;
    display: flex;

    justify-content: flex-end;

    .f-icon {
      cursor: help;
      position: relative;
      margin-left: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      display: flex;
      padding: 8px;
      background-color: #00000017;
      border-radius: 3px;
    }
  }

  .action {
    display: flex;
    align-items: center;
    height: 100%;
    padding-bottom: 8px;
  }

  .f-project-tabs-drop-placeholder {
    margin: 0 4px;
    background-color: var(--greyLight);
    border-radius: 8px 8px 0px 0px;
  }

  .f-project-tabs-drag {
    .f-project-tab {
      background-color: #efefee85;
      border-radius: 8px 8px 0px 0px;
      cursor: grab;
    }

    .separator {
      border-right: 1px solid transparent;
    }
  }
}
</style>



<style lang="scss">
// transparent background override
.f-project-tabs.transparent-background {
  background: var(--black-a50);

  .new .f-wrapper {
    background-color: var(--white-a10);
    color: var(--white);
  }

  .info .f-icon {
    color: var(--white);
    background-color: var(--white-a25);
  }

  .f-project-tabs-drag {
    .f-project-tab {
      background-color: var(--white-a25);
    }
  }

  .f-project-tabs-drop-placeholder {
    background-color: var(--white-a5);

    .separator {
      border-right-color: transparent;
    }
  }
}
</style>